import { render, staticRenderFns } from "./goldenSentenceIndex.vue?vue&type=template&id=9bd5f82c&scoped=true&"
import script from "./goldenSentenceIndex.vue?vue&type=script&lang=js&"
export * from "./goldenSentenceIndex.vue?vue&type=script&lang=js&"
import style0 from "./goldenSentenceIndex.vue?vue&type=style&index=0&id=9bd5f82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd5f82c",
  null
  
)

export default component.exports